import React from 'react';
import { ExternalLink, Globe, Link2, Plus, ArrowUpRight } from 'lucide-react';
export function ExternalLinksView() {
  const links = [{
    id: 1,
    name: 'Main Website',
    url: 'https://theculturegourmet.com',
    category: 'Corporate'
  }, {
    id: 2,
    name: 'Reservation Portal',
    url: 'https://opentable.com/culture-gourmet',
    category: 'Operations'
  }, {
    id: 3,
    name: 'Employee Handbook',
    url: 'https://docs.google.com/handbook',
    category: 'Internal'
  }, {
    id: 4,
    name: 'Social Media - Instagram',
    url: 'https://instagram.com/culturegourmet',
    category: 'Marketing'
  }];
  return <div className="space-y-6" data-id="element-179">
      <div className="flex items-center justify-between" data-id="element-180">
        <div data-id="element-181">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-182">External Links</h2>
          <p className="text-sm text-slate-500" data-id="element-183">
            Quick access to external resources and portals
          </p>
        </div>
        <button className="flex items-center gap-2 px-6 py-2 bg-emerald-500 text-white rounded-xl text-sm font-bold shadow-lg shadow-emerald-500/20 hover:bg-emerald-600 transition-all" data-id="element-184">
          <Plus size={16} data-id="element-185" />
          Add Link
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-186">
        {links.map(link => <a key={link.id} href={link.url} target="_blank" rel="noopener noreferrer" className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm hover:border-emerald-200 hover:shadow-md transition-all group" data-id="element-187">
            <div className="flex items-start justify-between mb-4" data-id="element-188">
              <div className="w-10 h-10 bg-slate-50 rounded-xl flex items-center justify-center text-slate-400 group-hover:bg-emerald-50 group-hover:text-emerald-500 transition-colors" data-id="element-189">
                <Globe size={20} data-id="element-190" />
              </div>
              <ArrowUpRight size={16} className="text-slate-300 group-hover:text-emerald-500 transition-colors" data-id="element-191" />
            </div>
            <h4 className="text-sm font-bold text-slate-900 mb-1" data-id="element-192">
              {link.name}
            </h4>
            <p className="text-[10px] text-slate-400 font-medium uppercase tracking-wider mb-3" data-id="element-193">
              {link.category}
            </p>
            <p className="text-xs text-slate-500 truncate" data-id="element-194">{link.url}</p>
          </a>)}
      </div>
    </div>;
}